import { isAxiosError } from "axios";

/**
 * Default retry policy for react-query.
 *
 * Never retry 4xx: the axios clients' auth interceptor already performs the
 * one legitimate 401 refresh-retry (and ends the session when that fails),
 * so retrying at this layer would triple-hit the API and re-trigger the
 * session teardown. Network errors and 5xx get up to two retries.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (isAxiosError(error)) {
    const status = error.response?.status;
    if (status !== undefined && status >= 400 && status < 500) {
      return false;
    }
  }
  return failureCount < 2;
}
